import { createInjectionKey as e } from "./ghl-ui.es896.js";
const n = e("n-drawer-body"), o = e("n-drawer");
export {
  n as drawerBodyInjectionKey,
  o as drawerInjectionKey
};
